import dayjs from 'dayjs';
import { ProfileData } from 'interfaces/authentication';
import LocalStorage from '../bom-dom-manipulation/local-storage';
import { storageKeyName } from '../generic/storage-key-name';

export const getUserName = (user: ProfileData): string => {
  const name =
    user?.first_name !== null && user?.last_name !== null
      ? `${user.first_name} ${user.last_name}`
      : user.username;

  return name || '';
};

export const getUserAvatarName = (user: ProfileData): string => {
  return getUserName(user).substr(0, 2).toUpperCase();
};

export const ITEMS_WITH_BADGE = ['bonuses', 'messages'];

export const setUserLoginLimitStartTimeLS = () =>
  LocalStorage.setItem(
    storageKeyName('account', 'LOGIN_LIMIT_POPUP_START_TIME'),
    String(dayjs().unix())
  );
